import { Alert, AlertColor } from '@mui/material';

export interface messageProps {
  message: string;
  severity: AlertColor;
}

export default function Banner(props: messageProps) {
  if (!props.message) {
    return null;
  }

  return <Alert severity={props.severity}>{props.message}</Alert>;
}
